import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from './Header'
import Footer from './Footer'
import FloatingWhatsApp from '../Components/WhatSapp/FloatingWhatsApp'

const Layouts = () => {
  return (
    <div>
        <Navbar/>
        <Outlet/>
        
                            <FloatingWhatsApp />
        <Footer/>
    </div>
  )
}

export default Layouts